// import React, { useEffect } from "react";
// import { useState } from "react";

// // Chakra imports
// import {
//   Flex,
//   Icon,
//   Image,
//   Text,
//   useColorModeValue,
//   Link,
//   Button,
//   IconButton,
//   Tooltip,
//   useClipboard
// } from "@chakra-ui/react";
// // Custom components
// import Card from "components/card/Card.js";
// // Assets
// import { StarIcon, TriangleUpIcon } from "@chakra-ui/icons";
// import Amazon from 'assets/img/amazon.ico';
// import Flipkart from 'assets/img/flipkart.ico';
// import Snapdeal from 'assets/img/snapdeal.ico';
// import Meesho from 'assets/img/meesho.ico';
// import Glowroad from 'assets/img/glowroad.ico'
// import Shopsy from 'assets/img/shopsy.ico';
// import freeup from 'assets/img/freeup.ico';

// import { MdCheckCircle, MdCancel, MdOutlineError, MdShoppingCart, MdContentCopy, MdAlbum } from "react-icons/md";




// export default function Item(props) {
//   const { product, handleInsertSeller, removeFromInsert, selectAll, first, insertSeller, index, isAdmin } = props;
//   // Chakra Color Mode
//   const textColor = useColorModeValue("brands.900", "white");
//   const bgItem = useColorModeValue(
//     { bg: "white", boxShadow: "0px 40px 58px -20px rgba(112, 144, 176, 0.12)" },
//     { bg: "navy.700", boxShadow: "unset" }
//   );
//   const textColorDate = useColorModeValue("secondaryGray.600", "white");
//   const { hasCopied, onCopy } = useClipboard(product.prod_code);
//   // const [toggleX, setToggleX] = useState(false);
//   // const [toggleOg, setToggleOg] = useState(false);
//   const [toggle, setToggle] = useState(false);
//   const [toggleTest, setToggleTest] = useState(false);

//   const handleToggle = async (pd_id, title, keyword_id) => {
//     const newToggle = !toggle;
//     setToggle(newToggle);
//     // console.log("title", title.slice(0,30))
//     if (newToggle) {
//       await handleInsertSeller(pd_id,title?.slice(0,30),keyword_id);
//     } else {
//       await removeFromInsert(pd_id);
//     }
//   };


//   useEffect(() => {
//     setToggle(false);
//   }, [product]);

//   useEffect(() => {
//     if (!first) {
//       if (selectAll) {
//         setToggle(true);
//       } else {
//         setToggle(false);
//         // //console.log(insertSeller)

//       }
//     }
//   }, [selectAll, first]);




//   const getPlatformIcon = (platformId) => {
//     switch (platformId) {
//       case 1:
//         return Amazon; // Use imported Amazon icon
//       case 2:
//         return Flipkart; // Use imported Flipkart icon
//       case 3:
//         return Snapdeal;// Use imported Snapdeal icon
//       case 4:
//         return Meesho;
//       case 5:
//         return Glowroad;
//       case 6:
//         return Shopsy;
//       case 7:
//         return freeup;

//     }
//   };

//   const renderStars = (rating) => {
//     rating = rating==-1 ? 0 : rating
//     const filledStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const totalStars = filledStars + (hasHalfStar ? 1 : 0);
//     const stars = [];

//     for (let i = 0; i < filledStars; i++) {
//       stars.push(<Icon as={StarIcon} color="gold" key={`star-${i}`} />);
//     }

//     if (hasHalfStar) {
//       stars.push(<Icon as={StarIcon} color="gold" key={`half-star`} />);
//     }

//     const emptyStars = 5 - totalStars;
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<Icon as={StarIcon} color="gray.300" key={`empty-star-${i}`} />);
//     }

//     return stars;
//   };

//   return (
//     <Card
//       _hover={bgItem}
//       bg='transparent'
//       boxShadow='unset'
//       px='24px'
//       py='21px'
//       transition='0.2s linear'>
//       <Flex direction={{ base: "column" }} justify='center'>
//         <Flex position='relative' align='center'>
//           <Link href={product.image_link} isExternal me='15px'>
//             <Image src={product.image_link} w='80px' me='16px' />
//           </Link>
//           <Flex
//             direction='column'
//             w={{ base: "70%", md: "100%" }}
//             me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}>

//             <Text
//               color={textColor}
//               fontSize={{
//                 base: "md",
//               }}
//               mb='5px'
//               fontWeight='bold'
//               me='14px'
//             >
//               {index + 1}.&nbsp;&nbsp;
//               <Link href={product.prod_link} textDecoration='underline' isExternal>
//                 {product.title || product.prod_link }
//               </Link>
//             </Text>
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 {product.keyword}
//                 <Image src={getPlatformIcon(product.platform_id)} alt="platform icon" width="15px" />

//               </Text>
//             </Flex>
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 MRP :
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 mb='5px'
//                 fontWeight='bold'
//                 me='14px'
//               >
//                 Rs. {product.mrp}
//               </Text>
//             </Flex>
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Product Code
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='bold'
//               >
//                 {product.prod_code}
//               </Text>
//               <Tooltip label={hasCopied ? "Copied!" : "Copy to Clipboard"}>
//                 <IconButton
//                   aria-label="Copy to Clipboard"
//                   icon={<MdContentCopy />}
//                   onClick={onCopy}
//                   variant="ghost"
//                   colorScheme={hasCopied ? "green" : "gray"}
//                   height='17px'
//                 />
//               </Tooltip>
//             </Flex>
//             {/* brand_image_check */}
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Verification Status:
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='semibold'
//                 mb='5px'
//                 me='14px'
//               >
//                 &nbsp;&nbsp; {product.brand_image_check ? product.brand_image_check : "Null"}
//               </Text>
//             </Flex>
//             {/* tet status */}
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Text Status:
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='semibold'
//                 mb='5px'
//                 me='14px'
//               >
//                 &nbsp;&nbsp; {product.text_status ? product.text_status : "Null"}
//               </Text>
//             </Flex>
//             <Flex direction='row'>
//               {renderStars(product.overall_rating)}
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 &nbsp;&nbsp;{product.no_of_rating}
//               </Text>
//             </Flex>
//           </Flex>
//           {isAdmin && (
//             <Flex
//               me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
//               align='center' direction="column">
//               <Tooltip label='Select'>
//                 <Button colorScheme='gray' fontSize="20px" p='0px' onClick={() => handleToggle(product.pd_id, product.title, product.keyword_id)}>
//                   <Icon color={insertSeller.some(p => p.pd_id === product.pd_id) ? 'green' : 'gray'} as={MdAlbum} />
//                 </Button>
//               </Tooltip>
//               {/* <Tooltip label='Mark as Verified'>
//               <Button colorScheme='gray' fontSize="20px" p='0px' onClick={() => handleToggleOg(product.pd_id)}>
//                 <Icon color={toggleOg === true ? 'green' : 'gray'} as={MdCheckCircle} />
//               </Button>
//             </Tooltip>
//             <Tooltip label='Test Purchase'>
//               <Button colorScheme="gray" fontSize="20px" p='0px'
//                 onClick={() => handleToggleTest(product.keyword_id, product.platform_id, product.seller_name)}>
//                 <Icon color={toggleTest === true ? 'blue' : 'gray'} as={MdShoppingCart} />
//               </Button>
//             </Tooltip> */}

//             </Flex>
//           )}


//         </Flex>

//       </Flex>
//     </Card>
//   );
// }


// import React, { useEffect, useState } from "react";
// import {
//   Flex,
//   Icon,
//   Image,
//   Text,
//   useColorModeValue,
//   Link,
//   Button,
//   IconButton,
//   Tooltip,
//   useClipboard,
//   Badge,
//   HStack,
//   VStack,
//   Divider,
//   Box
// } from "@chakra-ui/react";
// import Card from "components/card/Card.js";
// import { StarIcon } from "@chakra-ui/icons";
// import { MdContentCopy, MdAlbum } from "react-icons/md";
// import Amazon from 'assets/img/amazon.ico';
// import Flipkart from 'assets/img/flipkart.ico';
// import Snapdeal from 'assets/img/snapdeal.ico';
// import Meesho from 'assets/img/meesho.ico';
// import Glowroad from 'assets/img/glowroad.ico'
// import Shopsy from 'assets/img/shopsy.ico';
// import freeup from 'assets/img/freeup.ico';


// export default function Item(props) {
//   const { product, handleInsertSeller, removeFromInsert, selectAll, first, insertSeller, index, isAdmin, viewMode } = props;

//   const textColor = useColorModeValue("brands.900", "white");
//   const subTextColor = "secondaryGray.600";
//   const borderColor = useColorModeValue("gray.100", "whiteAlpha.100");

//   const { hasCopied, onCopy } = useClipboard(product.prod_code);
//   const [toggle, setToggle] = useState(false);
//   const isGrid = viewMode === "grid";

//   // Status Color Logic
//   const getStatusColor = (status) => {
//     if (!status || status === "Null") return "gray";
//     const s = status.toLowerCase();
//     if (s.includes("verify") || s.includes("pass") || s.includes("ok")) return "green";
//     if (s.includes("pending") || s.includes("check")) return "orange";
//     return "red";
//   };

//   const handleToggle = async (pd_id, title, keyword_id) => {
//     const newToggle = !toggle;
//     setToggle(newToggle);
//     if (newToggle) {
//       await handleInsertSeller(pd_id, title?.slice(0, 30), keyword_id);
//     } else {
//       await removeFromInsert(pd_id);
//     }
//   };

//     const getPlatformIcon = (platformId) => {
//     switch (platformId) {
//       case 1:
//         return Amazon; // Use imported Amazon icon
//       case 2:
//         return Flipkart; // Use imported Flipkart icon
//       case 3:
//         return Snapdeal;// Use imported Snapdeal icon
//       case 4:
//         return Meesho;
//       case 5:
//         return Glowroad;
//       case 6:
//         return Shopsy;
//       case 7:
//         return freeup;

//     }
//   };

//   const renderStars = (rating) => {
//     rating = rating === -1 ? 0 : rating;
//     return (
//       <HStack spacing='2px'>
//         {[...Array(5)].map((_, i) => (
//           <Icon
//             key={i}
//             as={StarIcon}
//             color={i < Math.floor(rating) ? "orange.400" : "gray.300"}
//             fontSize='12px'
//           />
//         ))}
//       </HStack>
//     );
//   };

//   return (
//     // <Card
//     //   p='20px'
//     //   variant='flex'
//     //   bg={useColorModeValue("white", "navy.800")}
//     //   transition='0.2s linear'
//     //   _hover={{ shadow: "md" }}
//     //   mb='10px'
//     // >
//     //   <Flex direction='row' align='center' justify='space-between' w='100%'>

//     //     {/* LEFT SECTION: IMAGE & PRIMARY DETAILS */}
//     //     <Flex align='center' flex='1'>
//     //       <Text fontWeight='bold' me='10px' color={subTextColor}>{index + 1}.</Text>
//     //       <Link href={product.image_link} isExternal me='20px'>
//     //         <Image 
//     //           src={product.image_link} 
//     //           w='100px' h='100px' 
//     //           minW='70px'
//     //           objectFit='contain' 
//     //           borderRadius='8px'
//     //           bg='gray.50'
//     //         />
//     //       </Link>

//     //       <VStack align='start' spacing='4px'>
//     //         <Link href={product.prod_link} isExternal>
//     //           <Text color={textColor} fontWeight='700' fontSize='md' noOfLines={1} maxW='400px'>
//     //             {product.title || product.prod_link}
//     //           </Text>
//     //         </Link>

//     //         <HStack>
//     //           <Image src={getPlatformIcon(product.platform_id)} w='14px' h='14px' />
//     //           <Text color={subTextColor} fontSize='sm'>{product.keyword}</Text>
//     //           <Divider orientation='vertical' h='12px' />
//     //           <Text color={textColor} fontWeight='600' fontSize='sm'>Rs. {product.mrp}</Text>
//     //         </HStack>

//     //         <HStack spacing='4px'>
//     //           <Text fontSize='xs' color={subTextColor}>Code: <b>{product.prod_code}</b></Text>
//     //           <Tooltip label={hasCopied ? "Copied!" : "Copy Code"}>
//     //             <IconButton
//     //               size='xs'
//     //               aria-label='copy'
//     //               icon={<MdContentCopy />}
//     //               onClick={onCopy}
//     //               variant='ghost'
//     //             />
//     //           </Tooltip>
//     //         </HStack>

//     //         <HStack spacing='8px'>
//     //           {renderStars(product.overall_rating)}
//     //           <Text fontSize='xs' color={subTextColor}>{product.no_of_rating}</Text>
//     //         </HStack>
//     //       </VStack>
//     //     </Flex>

//     //     {/* RIGHT SECTION: STATUS & ACTIONS */}
//     //     <HStack spacing='24px' align='center'>
//     //       <Divider orientation='vertical' h='60px' borderColor={borderColor} />

//     //       <VStack align='end' spacing='8px' minW='140px'>
//     //         <Box>
//     //           <Text fontSize='10px' fontWeight='bold' color={subTextColor} textAlign='right' mb='2px'>VERIFICATION</Text>
//     //           <Badge 
//     //             colorScheme={getStatusColor(product.brand_image_check)} 
//     //             variant='subtle' 
//     //             borderRadius='full' 
//     //             px='10px'
//     //           >
//     //             {product.brand_image_check || "N/A"}
//     //           </Badge>
//     //         </Box>

//     //         <Box>
//     //           <Text fontSize='10px' fontWeight='bold' color={subTextColor} textAlign='right' mb='2px'>TEXT STATUS</Text>
//     //           <Badge 
//     //             colorScheme={getStatusColor(product.text_status)} 
//     //             variant='outline' 
//     //             borderRadius='full' 
//     //             px='10px'
//     //           >
//     //             {product.text_status || "N/A"}
//     //           </Badge>
//     //         </Box>
//     //       </VStack>

//     //       {isAdmin && (
//     //         <Tooltip label={insertSeller.some(p => p.pd_id === product.pd_id) ? 'Deselect' : 'Select'}>
//     //           <IconButton
//     //             size='lg'
//     //             variant='ghost'
//     //             icon={<MdAlbum />}
//     //             color={insertSeller.some(p => p.pd_id === product.pd_id) ? 'green.500' : 'gray.300'}
//     //             onClick={() => handleToggle(product.pd_id, product.title, product.keyword_id)}
//     //             _hover={{ bg: "transparent", transform: "scale(1.2)" }}
//     //           />
//     //         </Tooltip>
//     //       )}
//     //     </HStack>
//     //   </Flex>
//     // </Card>
//     <Card
//       p='16px'
//       bg={useColorModeValue("white", "navy.800")}
//       transition='0.2s linear'
//       _hover={{ shadow: "lg", transform: isGrid ? "translateY(-4px)" : "none" }}
//       mb={isGrid ? "0px" : "10px"}
//       border={isGrid ? "1px solid" : "none"}
//       borderColor={borderColor}
//     >
//       <Flex direction={isGrid ? "column" : "row"} align={isGrid ? "start" : "center"} justify='space-between' w='100%'>

//         {/* LEFT/TOP SECTION */}
//         <Flex direction={isGrid ? "column" : "row"} align={isGrid ? "start" : "center"} flex='1' w="100%">
//           <Text fontWeight='bold' me='10px' color={subTextColor} display={isGrid ? "none" : "block"}>
//             {index + 1}.
//           </Text>

//           <Link href={product.image_link} isExternal me={isGrid ? "0" : "20px"} w={isGrid ? "100%" : "auto"} mb={isGrid ? "12px" : "0"}>
//             <Image 
//               src={product.image_link} 
//               w={isGrid ? "100%" : "100px"} 
//               h={isGrid ? "150px" : "100px"} 
//               objectFit='contain' 
//               borderRadius='8px'
//               bg='gray.50'
//             />
//           </Link>

//           <VStack align='start' spacing='4px' w="100%">
//             <Link href={product.prod_link} isExternal>
//               <Text color={textColor} fontWeight='700' fontSize='sm' noOfLines={isGrid ? 2 : 1}>
//                 {isGrid && `${index + 1}. `}{product.title || product.prod_link}
//               </Text>
//             </Link>

//             <HStack wrap="wrap">
//               <Image src={getPlatformIcon(product.platform_id)} w='15px' h='15px' />
//               <Text color={subTextColor} fontWeight='500' fontSize='sm'>{product.keyword}</Text>
//               {!isGrid && <Divider orientation='vertical' h='12px' />}
//               <Text color={textColor} fontWeight='700' fontSize='sm'>₹{product.mrp}</Text>
//             </HStack>

//             <HStack spacing='4px'>
//               <Text fontSize='xs' color={subTextColor}>Code: {product.prod_code}</Text>
//               <IconButton size='xs' icon={<MdContentCopy />} onClick={onCopy} variant='ghost' />
//             </HStack>

//             <Box>{renderStars(product.overall_rating)}</Box>
//           </VStack>
//         </Flex>

//         {/* RIGHT/BOTTOM SECTION (Status & Actions) */}
//         <Flex 
//           direction={isGrid ? "row" : "row"} 
//           align="center" 
//           justify="space-between" 
//           w={isGrid ? "100%" : "auto"} 
//           mt={isGrid ? "15px" : "0"}
//           pt={isGrid ? "10px" : "0"}
//           borderTop={isGrid ? "1px solid" : "none"}
//           borderColor={borderColor}
//         >
//           {!isGrid && <Divider orientation='vertical' h='60px' mx="20px" borderColor={borderColor} />}

//           <VStack align={isGrid ? "start" : "end"} spacing='4px' minW={isGrid ? "auto" : "140px"}>
//             <Badge colorScheme={getStatusColor(product.brand_image_check)} variant='subtle' borderRadius='full' px='8px' fontSize="9px">
//               Verification Status: {product.brand_image_check || "Null"}
//             </Badge>
//             <Badge colorScheme={getStatusColor(product.text_status)} variant='outline' borderRadius='full' px='8px' fontSize="9px">
//               Text Status: {product.text_status || "Null"}
//             </Badge>
//           </VStack>

//           {isAdmin && (
//             <IconButton
//               ml="10px"
//               size='md'
//               variant='ghost'
//               icon={<MdAlbum />}
//               color={insertSeller.some(p => p.pd_id === product.pd_id) ? 'green.500' : 'gray.300'}
//               onClick={() => handleToggle(product.pd_id, product.title, product.keyword_id)}
//             />
//           )}
//         </Flex>
//       </Flex>
//     </Card>
//   );
// }


// import React, { useState } from "react";
// import {
//   Flex,
//   Icon,
//   Image,
//   Text,
//   useColorModeValue,
//   Link,
//   Button,
//   IconButton,
//   Tooltip,
//   useClipboard,
//   Badge,
//   HStack,
//   VStack,
//   Divider,
//   Box,
// } from "@chakra-ui/react";
// import Card from "components/card/Card.js";
// import { StarIcon } from "@chakra-ui/icons";
// import { MdContentCopy, MdAlbum } from "react-icons/md";

// // Asset Imports
// import Amazon from 'assets/img/amazon.ico';
// import Flipkart from 'assets/img/flipkart.ico';
// import Snapdeal from 'assets/img/snapdeal.ico';
// import Meesho from 'assets/img/meesho.ico';
// import Glowroad from 'assets/img/glowroad.ico'
// import Shopsy from 'assets/img/shopsy.ico';
// import freeup from 'assets/img/freeup.ico';

// /**
//  * 1. GRID VIEW COMPONENT (E-Commerce Style)
//  */
// const GridItemView = ({ 
//   product, index, textColor, subTextColor, borderColor, 
//   onCopy, hasCopied, getPlatformIcon, renderStars, getStatusColor, 
//   isAdmin, isSelected, handleToggle 
// }) => {
//   return (
//     <Card
//       p='0px'
//       bg={useColorModeValue("white", "navy.800")}
//       transition='0.3s cubic-bezier(.25,.8,.25,1)'
//       _hover={{ shadow: "md", transform: "translateY(-3px)" }}
//       border='1px solid'
//       borderColor={borderColor}
//       overflow='hidden'
//       h="100%"
//       display="flex"
//       flexDirection="column"
//     >
//       {/* IMAGE SECTION - 220px Height for "Big" feel */}
//       <Box position='relative' bg='white' p='10px' h='220px' borderBottom="1px solid" borderColor={borderColor}>
//         <Link href={product.prod_link} isExternal w='100%' h='100%' display="block">
//           <Image 
//             src={product.image_link} 
//             w='100%' h='100%' 
//             objectFit='contain' 
//           />
//         </Link>
        
//         {/* PLATFORM ICON OVERLAY (Top Left) */}
//         <Box position='absolute' top='10px' left='10px' bg="white" borderRadius="md" p="1" shadow="md">
//           <Image src={getPlatformIcon(product.platform_id)} w='20px' h='20px' />
//         </Box>

//         {/* STATUS BADGES OVERLAY (Top Right) */}
//         <VStack position='absolute' top='10px' right='10px' align="end" spacing="4px">
//           <Tooltip label={"Verification Status"}>
//           <Badge colorScheme={getStatusColor(product.brand_image_check)} variant='solid' fontSize='10px' borderRadius="full" px="2">
//             {product.brand_image_check || "N/A"}
//           </Badge>
//           </Tooltip>
//           <Tooltip label={"Text Status"}>

//           <Badge colorScheme={getStatusColor(product.text_status)} variant='subtle' fontSize='10px' borderRadius="full" px="2" border="1px solid">
//             {product.text_status || "N/A"}
//           </Badge>
//           </Tooltip>
//         </VStack>
//       </Box>

//       {/* CONTENT SECTION */}
//       <VStack p='16px' align='start' spacing='10px' flex='1'>
//         {/* Title */}
//         <Link href={product.prod_link} isExternal w="100%">
//           <Text color={textColor} fontWeight='700' fontSize='md' noOfLines={2} lineHeight="1.3" h="42px">
//             {product.title || product.prod_link}
//           </Text>
//         </Link>

//         {/* Keyword / Brand Info */}
//         <Text color={subTextColor} fontSize='xs' fontWeight="bold" textTransform="uppercase" letterSpacing="wider">
//           {product.keyword || "General"}
//         </Text>

//         {/* MRP / Pricing */}
//         <HStack w="100%" justify="space-between" align="center">
//           <Text color={textColor} fontWeight='900' fontSize='xl'>
//             ₹{product.mrp}
//           </Text>
//           <HStack spacing='2px'>
//             {renderStars(product.overall_rating)}
//           </HStack>
//         </HStack>

//         {/* Product Code */}
//         <HStack w='100%' justify='space-between' bg="gray.50" p="2" borderRadius="md">
//           <Text fontSize='12px' color={subTextColor} >
//             Code: <b> {product.prod_code}</b>
//           </Text>
//           <Tooltip label={hasCopied ? "Copied!" : "Copy"}>
//             <IconButton size='xs' icon={<MdContentCopy />} onClick={onCopy} variant='ghost' />
//           </Tooltip>
//         </HStack>
//       </VStack>

//       {/* FOOTER ACTION */}
//       {isAdmin && (
//         <Button
//           leftIcon={<MdAlbum />}
//           colorScheme={isSelected ? "green" : "gray"}
//           variant={isSelected ? "solid" : "ghost"}
//           borderRadius='0px'
//           size='lg'
//           w="100%"
//           fontSize="sm"
//           onClick={handleToggle}
//           borderTop="1px solid"
//           borderColor={borderColor}
//         >
//           {isSelected ? "ADDED TO LIST" : "SELECT SELLER"}
//         </Button>
//       )}
//     </Card>
//   );
// };

// /**
//  * 2. LIST VIEW COMPONENT (Horizontal Row)
//  */
// const ListItemView = ({
//   product, index, textColor, subTextColor, borderColor,
//   onCopy, hasCopied, getPlatformIcon, renderStars, getStatusColor,
//   isAdmin, isSelected, handleToggle
// }) => {
//   return (
//     <Card p='16px' mb='10px' variant='flex' _hover={{ shadow: "md" }} borderColor={borderColor}>
//       <Flex align='center' w='100%'>
//         <Text fontWeight='bold' me='15px' color={subTextColor} w="20px">{index + 1}.</Text>
//         <Link href={product.image_link} isExternal me='15px'>
//           <Image
//             src={product.image_link}
//             w='100px' h='100px' objectFit='contain'
//             borderRadius='8px' bg='gray.50' me='20px'
//           />
//         </Link>

//         <VStack align='start' spacing='2px' flex='1'>
//           <Link href={product.prod_link} isExternal>
//             <Text color={textColor} fontWeight='700' fontSize='md' noOfLines={1}>
//               {product.title || product.prod_link}
//             </Text>
//           </Link>
//           <HStack spacing="15px">
//             <HStack>
//               <Image src={getPlatformIcon(product.platform_id)} w='15px' h='15px' />
//               <Text color={subTextColor} fontSize='xs'>{product.keyword}</Text>
//             </HStack>
//             <Text color={textColor} fontWeight='700' fontSize='sm'>₹{product.mrp}</Text>
//           </HStack>
//           <HStack>
//             <Text fontSize='sm' color={subTextColor}>Code : <b>{product.prod_code}</b></Text>
//             <IconButton size='xs' icon={<MdContentCopy />} onClick={onCopy} variant='ghost' />
//           </HStack>
//           <HStack spacing='8px'>
//             {renderStars(product.overall_rating)}
//           </HStack>
//         </VStack>

//         <HStack spacing='24px' ml="auto">
//           <VStack align='end' spacing='4px'>
//             <Badge colorScheme={getStatusColor(product.brand_image_check)} px="2" borderRadius="full">
//               {product.brand_image_check || "N/A"}
//             </Badge>
//             <Badge colorScheme={getStatusColor(product.text_status)} variant="outline" px="2" borderRadius="full">
//               {product.text_status || "N/A"}
//             </Badge>
//           </VStack>
//           {isAdmin && (
//             <IconButton
//               size='lg'
//               variant='ghost'
//               icon={<MdAlbum />}
//               color={isSelected ? 'green.500' : 'gray.300'}
//               onClick={handleToggle}
//               _hover={{ bg: "transparent", transform: "scale(1.1)" }}
//             />
//           )}
//         </HStack>
//       </Flex>
//     </Card>
//   );
// };

// /**
//  * MAIN COMPONENT EXPORT
//  */
// export default function Item(props) {
//   const {
//     product, handleInsertSeller, removeFromInsert,
//     insertSeller, index, isAdmin, viewMode
//   } = props;

//   const textColor = useColorModeValue("brands.900", "white");
//   const subTextColor = "secondaryGray.600";
//   const borderColor = useColorModeValue("gray.100", "whiteAlpha.100");
//   const { hasCopied, onCopy } = useClipboard(product.prod_code);

//   const isSelected = insertSeller.some((p) => p.pd_id === product.pd_id);

//   const getStatusColor = (status) => {
//     if (!status || status === "Null") return "gray";
//     const s = status.toLowerCase();
//     if (s.includes("verify") || s.includes("pass") || s.includes("ok")) return "green";
//     if (s.includes("pending") || s.includes("check")) return "orange";
//     return "red";
//   };

//   const handleToggle = async () => {
//     if (!isSelected) {
//       await handleInsertSeller(product.pd_id, product.title?.slice(0, 30), product.keyword_id);
//     } else {
//       await removeFromInsert(product.pd_id);
//     }
//   };

//   const getPlatformIcon = (platformId) => {
//     switch (platformId) {
//       case 1: return Amazon;
//       case 2: return Flipkart;
//       case 3: return Snapdeal;
//       case 4: return Meesho;
//       case 5: return Glowroad;
//       case 6: return Shopsy;
//       case 7: return freeup;
//       default: return null;
//     }
//   };

//   const renderStars = (rating) => {
//     const val = rating === -1 ? 0 : rating;
//     return (
//       <HStack spacing='2px'>
//         {[...Array(5)].map((_, i) => (
//           <Icon
//             key={i}
//             as={StarIcon}
//             color={i < Math.floor(val) ? "orange.400" : "gray.300"}
//             fontSize='13px'
//           />
//         ))}
//       </HStack>
//     );
//   };

//   const sharedProps = {
//     product, index, textColor, subTextColor, borderColor,
//     onCopy, hasCopied, getPlatformIcon, renderStars, getStatusColor,
//     isAdmin, isSelected, handleToggle
//   };

//   return viewMode === "grid" ? (
//     <GridItemView {...sharedProps} />
//   ) : (
//     <ListItemView {...sharedProps} />
//   );
// }


import React from "react";
import {
  Flex, Icon, Image, Text, useColorModeValue, Link, Button,
  IconButton, Tooltip, useClipboard, Badge, HStack, VStack, Box,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { StarIcon, CheckCircleIcon, WarningIcon, InfoIcon, NotAllowedIcon } from "@chakra-ui/icons";
import { MdContentCopy, MdAlbum } from "react-icons/md";

// Asset Imports
import Amazon from 'assets/img/amazon.ico';
import Flipkart from 'assets/img/flipkart.ico';
import Snapdeal from 'assets/img/snapdeal.ico';
import Meesho from 'assets/img/meesho.ico';
import Glowroad from 'assets/img/glowroad.ico'
import Shopsy from 'assets/img/shopsy.ico';
import freeup from 'assets/img/freeup.ico';

/**
 * 1. GRID VIEW COMPONENT (E-Commerce Style)
 */
const GridItemView = ({ 
  product, index, textColor, subTextColor, borderColor, 
  onCopy, hasCopied, getPlatformIcon, renderStars, getStatusConfig, 
  isAdmin, isSelected, handleToggle 
}) => {
  const verifyConfig = getStatusConfig("verify", product.brand_image_check);
  const textConfig = getStatusConfig("text", product.text_status);

  return (
    <Card
      p='0px'
      bg={useColorModeValue("white", "navy.800")}
      transition='0.3s cubic-bezier(.25,.8,.25,1)'
      _hover={{ shadow: "md", transform: "translateY(-3px)" }}
      border={isSelected ? "2px solid":'1px solid'}
      borderColor={isSelected ? "green" : borderColor}
      overflow='hidden'
      h="100%"
      display="flex"
      flexDirection="column"
    >
      <Box position='relative' bg='white' p='10px' h='220px' borderBottom="1px solid" borderColor={borderColor}>
        <Link href={product.prod_link} isExternal w='100%' h='100%' display="block">
          <Image src={product.image_link} w='100%' h='100%' objectFit='contain' />
        </Link>
        <Tooltip label={product.platform_name}>
        <Box position='absolute' top='10px' left='10px' bg="white" borderRadius="md" p="1" shadow="md">
          <Image src={getPlatformIcon(product.platform_id) || `https://www.google.com/s2/favicons?domain=${product.platform_name}&sz=128`} w='20px' h='20px' />
        </Box>
        </Tooltip>

        {/* STATUS BADGES OVERLAY */}
        <VStack position='absolute' top='10px' right='10px' align="end" spacing="4px">
          <Tooltip label={`Verification: ${product.brand_image_check}`}>
            <Badge colorScheme={verifyConfig.color} variant='solid' fontSize='10px' borderRadius="full" px="2" display="flex" alignItems="center">
              <Icon as={verifyConfig.icon} mr="1" /> {product.brand_image_check ?? "N/A"}
            </Badge>
          </Tooltip>
          <Tooltip label={`Text Status: ${product.text_status}`}>
            <Badge colorScheme={textConfig.color} variant='subtle' fontSize='10px' borderRadius="full" px="2" border="1px solid" display="flex" alignItems="center">
              <Icon as={textConfig.icon} mr="1" /> {product.text_status ?? "N/A"}
            </Badge>
          </Tooltip>
        </VStack>
      </Box>

      <VStack p='16px' align='start' spacing='10px' flex='1'>
        <Link href={product.prod_link} isExternal w="100%">
          <Text color={textColor} fontWeight='700' fontSize='md' noOfLines={2} lineHeight="1.3" h="42px">
            {product.title || product.prod_link}
          </Text>
        </Link>

        <Text color={subTextColor} fontSize='xs' fontWeight="bold" textTransform="uppercase">
          {product.keyword || "General"}
        </Text>

        <HStack w="100%" justify="space-between" align="center">
          <Text color={textColor} fontWeight='900' fontSize='xl' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>₹{product.mrp < 0 ? "N/A" : product.mrp}</Text>
          <HStack spacing='2px'  hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>{renderStars(product.overall_rating)}</HStack>
        </HStack>

        <HStack w='100%' justify='space-between' bg="gray.50" p="2" borderRadius="md">
          <Text fontSize='12px' color={subTextColor}>Code: <b style={{color:"gray"}}>{product.prod_code}</b></Text>
          <IconButton size='xs' icon={<MdContentCopy />} onClick={onCopy} variant='ghost' />
        </HStack>
        
      </VStack>

      {isAdmin && (
        <Button
          leftIcon={<MdAlbum />}
          colorScheme={isSelected ? "green" : "gray"}
          variant={isSelected ? "solid" : "ghost"}
          borderRadius='0px'
          size='lg'
          w="100%"
          fontSize="sm"
          onClick={handleToggle}
          borderTop="1px solid"
          borderColor={borderColor}
        >
          {isSelected ? "ADDED TO LIST" : "SELECT SELLER"}
        </Button>
      )}
    </Card>
  );
};

/**
 * 2. LIST VIEW COMPONENT (Horizontal Row)
 */
const ListItemView = ({
  product, index, textColor, subTextColor, borderColor,
  onCopy, getPlatformIcon, renderStars, getStatusConfig,
  isAdmin, isSelected, handleToggle
}) => {
  const verifyConfig = getStatusConfig("verify", product.brand_image_check);
  const textConfig = getStatusConfig("text", product.text_status);

  return (
    <Card p='16px' mb='10px' variant='flex' _hover={{ shadow: "md" }} borderColor={borderColor}>
      <Flex align='center' w='100%'>
        <Text fontWeight='bold' me='15px' color={subTextColor} w="30px" textAlign="center">{index + 1}.</Text>
        <Link href={product.image_link} isExternal me='15px'>
          <Image src={product.image_link} w='100px' h='100px' objectFit='contain' borderRadius='8px' bg='gray.50' />
        </Link>

        <VStack align='start' spacing='2px' flex='1'>
          <Link href={product.prod_link} isExternal>
            <Text color={textColor} fontWeight='700' fontSize='md' noOfLines={1}>
              {product.title || product.prod_link}
            </Text>
          </Link>
          <HStack spacing="15px">
            <HStack>
              <Tooltip label={product.platform_name}>
                <Image src={getPlatformIcon(product.platform_id) || `https://www.google.com/s2/favicons?domain=${product.platform_name}&sz=128`} w='15px' h='15px' />
              </Tooltip>
              <Text color={subTextColor} fontSize='sm'>{product.keyword}</Text>
            </HStack>
            <Text color={textColor} fontWeight='700' fontSize='sm' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")} >₹{product.mrp || 0}</Text>
          </HStack>
          <HStack>
            <Text fontSize='sm' color={subTextColor}>Code : <b style={{color:"gray"}}>{product.prod_code}</b></Text>
            <IconButton size='xs' icon={<MdContentCopy />} onClick={onCopy} variant='ghost' />
          </HStack>
          <Box  hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>{renderStars(product.overall_rating)}</Box>
        </VStack>

        <HStack spacing='24px' ml="auto">
          <VStack align='end' spacing='4px'>
            <Badge colorScheme={verifyConfig.color} px="2" borderRadius="full" display="flex" alignItems="center">
              <Icon as={verifyConfig.icon} mr="1" /> V: {product.brand_image_check ?? "N/A"}
            </Badge>
            <Badge colorScheme={textConfig.color} variant="outline" px="2" borderRadius="full" display="flex" alignItems="center">
              <Icon as={textConfig.icon} mr="1" /> T: {product.text_status ?? "N/A"}
            </Badge>
          </VStack>
          {isAdmin && (
            <IconButton
              size='lg'
              variant='ghost'
              icon={<MdAlbum />}
              color={isSelected ? 'green.500' : 'gray.300'}
              onClick={handleToggle}
            />
          )}
        </HStack>
      </Flex>
    </Card>
  );
};

export default function Item(props) {
  const { product, handleInsertSeller, removeFromInsert, insertSeller, index, isAdmin, viewMode } = props;

  const textColor = useColorModeValue("brands.900", "white");
  const subTextColor = "secondaryGray.600";
  const borderColor = useColorModeValue("gray.100", "whiteAlpha.100");
  const { onCopy } = useClipboard(product.prod_code);
  const isSelected = insertSeller.some((p) => p.pd_id === product.pd_id);

  // LOGIC FOR STATUS COLORS AND ICONS
  const getStatusConfig = (type, value) => {
    const val = value === null || value === "Null" ? null : parseInt(value);
    
    if (type === "verify") {
      if (val === -1) return { color: "red", icon: NotAllowedIcon };
      if (val === null || (val >= 0 && val <= 3)) return { color: "yellow", icon: WarningIcon };
      if (val === 4) return { color: "orange", icon: InfoIcon };
      if (val === 5 || val === 6) return { color: "green", icon: CheckCircleIcon };
      return { color: "gray", icon: InfoIcon };
    } 
    
    if (type === "text") {
      if (val === -1) return { color: "red", icon: NotAllowedIcon };
      if (val === 0 || val === null) return { color: "yellow", icon: WarningIcon };
      if (val === 1) return { color: "green", icon: CheckCircleIcon };
      return { color: "gray", icon: InfoIcon };
    }
  };

  const handleToggle = async () => {
    if (!isSelected) {
      await handleInsertSeller(product.pd_id, product.title?.slice(0, 30), product.keyword_id);
    } else {
      await removeFromInsert(product.pd_id);
    }
  };

  const getPlatformIcon = (id) => {
    const icons = { 1: Amazon, 2: Flipkart, 3: Snapdeal, 4: Meesho, 5: Glowroad, 6: Shopsy, 7: freeup };
    return icons[id] || null;
  };

  const renderStars = (rating) => {
    const val = rating < 0 ? 0 : rating;
    return (
      <HStack spacing='2px'>
        {[...Array(5)].map((_, i) => (
          <Icon key={i} as={StarIcon} color={i < Math.floor(val) ? "orange.400" : "gray.300"} fontSize='13px' />
        ))}
      </HStack>
    );
  };

  const sharedProps = {
    product, index, textColor, subTextColor, borderColor,
    onCopy, getPlatformIcon, renderStars, getStatusConfig,
    isAdmin, isSelected, handleToggle
  };

  return viewMode === "grid" ? <GridItemView {...sharedProps} /> : <ListItemView {...sharedProps} />;
}